// extracted by mini-css-extract-plugin
export default {"name":"_2ad6pWYFYoMQ0oxIjeN3Ux","capacity":"nWYm2NVMc0saaw7GGyHXm","pricing":"_1Pm14m2w2vAT26U8QMoROp"};